import { gql } from '@apollo/client';

export const SEARCH_PUBLISHERS = gql`
  query SearchPublishers($searchTerm: String!, $limit: Int) {
    publisherSearch(searchTerm: $searchTerm, limit: $limit) {
      id
      name
      lastLogin
      lastActivity
      lastActivityType
      created
      modified
    }
  }
`;

export const GET_PUBLISHER_STATS = gql`
  query GetPublisherStats($publisherId: Int!) {
    publisherStats(publisherId: $publisherId)
  }
`;

export const GET_PUBLISHER_SETTINGS = gql`
  query GetPublisherSettings($publisherId: ID!) {
    publisher(id: $publisherId) {
      id
      enableSalesByRegion
      currency {
        id
        label
        symbol
      }
      accountingMethod
      # Add other fields if needed by RoyaltyAndCurrencySettings component
    }
  }
`;
